import React, { useEffect, useState } from 'react';
import '../CSS/ReportsGrid.css';

const ReportsGrid = () => {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        const filteredReports = data.reports.filter(report => report.fields.DM !== true);
        setReports(filteredReports.slice(0, 10));
      })
      .catch((error) => {
        console.error('Error fetching reports data:', error);
      });
  }, []);

  const openReport = (linkUrl, reportType = 'HomeReportsGrid') => {
    // Extract filename from the original SharePoint link
    const lastPart = linkUrl.split('/').pop();              // e.g. "7034-...pdf" (possibly URL-encoded)
    const fileName = decodeURIComponent(lastPart);          // normalize to plain text
    const url = `/api/reports/${encodeURIComponent(fileName)}`; // safe for path

    // Grab the user's email from localStorage (unified between MSAL and custom)
  const userEmail = localStorage.getItem('user-email');

  if (userEmail) {
    // Fire-and-forget log (non-blocking)
    fetch('/api/log-report', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true, // lets it complete even if page navigates
      body: JSON.stringify({
        reportName: fileName,      // goes into Title column
        reportType,                // the page/section (you can pass "Highlights", "Calendar", etc.)
        userEmail                  // goes into ClickedBy
      })
    }).catch(() => {}); // don’t break UX if logging fails
  }
  
    // Open via your proxy (no email in URL)
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  

  return (
    <div className="reports-grid">
      <div className="reports-header">
        <div className="header-item">Title</div>
        <div className="header-item">Report Date</div>
        <div className="header-item">Country</div>
        <div className="header-item">Sector</div>
      </div>

      {reports.map((report) => (
        <div className="report-row" key={report.fields.id}>
          <div className="report-item" data-label="Title">
          {report.fields.Links1 ? (
  <a
    href="#"
    onClick={(e) => {
      e.preventDefault();
      openReport(report.fields.Links1);
    }}
    className="report-item report-title"
  >
    {report.fields.Title}
  </a>
) : (
  <div className="report-item">{report.fields.Title}</div>
)}
          </div>

          <div className="report-item" data-label="Date">{report.fields.field_1_formatted}</div>
          <div className="report-item" data-label="Country">{report.fields.field_3}</div>
          <div className="report-item">
            {Array.isArray(report.fields.field_6)
              ? report.fields.field_6.join(', ')
              : report.fields.field_6 || ''}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportsGrid;
